"use client";

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Search, Notifications } from "@mui/icons-material";
import Image from "next/image";
import { IUserParent, IUserProfile } from "@/api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export default function NotConnected() {
  const navigate = useNavigate();
  const handleClick = () => {
    // debugger;
    navigate(`./connect-parent`);
  };
  return (
    <Box sx={{ textAlign: "center", py: 3 }}>
      <Typography color="textSecondary" sx={{ mb: 2 }}>
        Not Parent Information on your account yet. Please add your parent
      </Typography>
      <Button variant="contained" color="warning" onClick={handleClick}>
        Add Parent
      </Button>
    </Box>
  );
}
